import './editorial.css';

/**
 * PaywallBreak — the branded metered-preview cutoff inserted after the public
 * preview (Key Takeaway ¶1 + map). Business Class and above render the full
 * brief and never see this. Gated content must NOT be present in the markup
 * served to unauthenticated visitors — this component is the terminus of the
 * preview payload, not a visual mask over hidden text.
 */
export default function PaywallBreak({ onSubscribe, onLogin, price = 15 }) {
  return (
    <section className="bi-paywall" aria-label="Subscribe to continue">
      <span className="bi-paywall__mark" aria-hidden="true">
        <svg viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="17" strokeWidth="1.4" />
          <circle cx="20" cy="20" r="2.2" strokeWidth="1.2" />
          <polygon points="20,5 17.5,20 20,17 22.5,20" fill="currentColor" stroke="none" />
          <polygon points="20,35 17.5,20 20,23 22.5,20" strokeWidth="1" />
          <line x1="20" y1="3" x2="20" y2="7" strokeWidth="1" />
          <line x1="20" y1="33" x2="20" y2="37" strokeWidth="1" />
          <line x1="3" y1="20" x2="7" y2="20" strokeWidth="1" />
          <line x1="33" y1="20" x2="37" y2="20" strokeWidth="1" />
        </svg>
      </span>
      <p className="bi-paywall__eyebrow">The briefing continues for Business Class</p>
      <h2 className="bi-paywall__headline">Chart Your Bearing</h2>
      <p className="bi-paywall__dek">Full analysis, key developments, and threat assessments continue below.</p>
      <button type="button" className="bi-paywall__cta" onClick={onSubscribe}>
        Subscribe — ${price}/mo
      </button>
      <button type="button" className="bi-paywall__login" onClick={onLogin}>
        Already aboard? <u>Log in</u>
      </button>
    </section>
  );
}
